import { useEffect, React } from "react";
import Layout from "./../../components/Layout/Layout";
import { useState } from "react";
//import { ChevronUpIcon } from '@heroicons/react/solid'
import {
  CursorClickIcon,
  MailOpenIcon,
  UsersIcon,
} from "@heroicons/react/outline";
import TotalTransfer from "../../assets/images/transfers.png";
import TotalTransactions from "../../assets/images/total_transactions.png";
import Investment from "../../assets/images/investments.png";
import TotalDeposit from "../../assets/images/deposits.png";
//import TotalLoans from '../../assets/images/loans.png'
import TotalWithdrawals from "../../assets/images/withdrawals.png";
import TotalPayments from "../../assets/images/payments.png";
import * as RiIcons from "react-icons/ri";
import { Link } from "react-router-dom";
import TenantServices from "../../services/TenantServices";
import { FormatMoney } from "./../../utils/formatMoney";
import fire from "./../../utils/Toastr";
import TransferGraph from "../../components/Graph/lineGraph";
import BillGraph from "../../components/Graph/line";
import CustomerServices from "../../services/CustomerServices";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export default function Dashboard() {
  const [user, setUser] = useState({ firstName: "" });
  const [summary, setSummary] = useState({});
  const [status, setStatus] = useState({});
  const [appShutDown, setAppShutDown] = useState("");
  const [adminType, setAdmintype] = useState("");

  const getDetails = () => {
    var details = sessionStorage.getItem("user");
    const allValue = JSON.parse(details);
    setUser(JSON.parse(details));
    setAdmintype(allValue.adminType);

    var userDetails = JSON.parse(details);
    // var modules = [];
    var modules = userDetails.moduleAssigned.split(",");
    var checker = modules.find((x) => x === "application_shut_down");
    if (checker === "application_shut_down") {
      setAppShutDown(checker);
    }
  };

  const getSummary = async () => {
    const resp = await TenantServices.dashBoardSummary();
    setSummary(resp.data);
    const appStat = await TenantServices.getAppStatus("DisablePlatform");
    setStatus(appStat.data.applicationValue);
  };
  const shutdown = async () => {
    const resp = await TenantServices.shutDown({
      shutdownParamater: "DisablePlatform",
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }
  };

  const openApp = async () => {
    const resp = await TenantServices.openApp({
      shutdownParamater: "DisablePlatform",
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }
  };

  const ClearAllApplicationData = async () => {
    const response = await CustomerServices.ClearAllApplicationData({
      tenantId: sessionStorage.getItem("tenantId"),
    });
    if (response) {
      fire("success", response.message);
      setTimeout(() => {
        window.location.reload();
      }, 4000);
    }
  };

  useEffect(() => {
    getDetails();
    getSummary();
  }, []);
  return (
    <>
      <Layout title={""} pageTag={"dashboard"} current={"/dashboard"}>
        <div>
          <div className="flex justify-between">
            <div>
              <h2>Hello {user.firstName},</h2>
              <p className="mb-5">Welcome to your PremiumTrust dashboard</p>
            </div>

            <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none flex items-center justify-center gap-2">
              {/* Only render Purge Redis button if adminType is "checker" */}
              {adminType.toLowerCase() === "checker" && (
                <div className="p-2">
                  <button
                    onClick={ClearAllApplicationData}
                    className="px-4 py-2 bg-slate-800 text-red-600 text-bold rounded-md shadow-sm hover:text-white active:text-white inline-flex hover:bg-red-200"
                  >
                    Purge Redis
                    <RiIcons.RiAlertFill className="w-4 h-4 mx-1.5 text-2xl" />
                  </button>
                </div>
              )}

              <Link
                type="button"
                to="/customers"
                className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent  px-2 py-2 text-sm font-medium text-red-500 shadow-sm  bg-red-200 sm:w-auto"
              >
                Fraud Alert - Block Customer
                <RiIcons.RiAlertFill className="w-4 mx-1.5 text-2xl" />
              </Link>
              {adminType.toLowerCase() === "checker" ? (
                <>
                  {appShutDown === "application_shut_down" ? (
                    <>
                      {status === "NO" ? (
                        <button
                          type="button"
                          onClick={shutdown}
                          className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent  px-2 py-2 text-sm font-medium text-red-500 shadow-sm  bg-red-200 sm:w-auto"
                        >
                          Shut Down App
                          <RiIcons.RiAlertFill className="w-4 mx-1.5 text-2xl" />
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={openApp}
                          className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent  px-2 py-2 text-sm font-medium text-green-500 shadow-sm  bg-green-200 sm:w-auto"
                        >
                          Open App
                          <RiIcons.RiAlertFill className="w-4 mx-1.5 text-2xl" />
                        </button>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className=" mb-10">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
              <div className="col-span-1 flex flex-col bg-slate-800 text-center rounded-lg shadow divide-y divide-gray-200">
                <div className="relative flex pt-8 px-4 mt-12 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                  <div className="absolute bg-blue-100 rounded-md p-3">
                    <img
                      src={TotalTransactions}
                      alt="transactions"
                      className="h-8 w-8 text-gray-900"
                      aria-hidden="true"
                    />
                  </div>
                  <div className="mt-28">
                    <p className="text-sm font-medium text-white truncate">
                      Total Transactions
                    </p>
                    <p className="text-2xl font-semibold text-white">
                      {FormatMoney(summary.totalTransactionsAmount)}
                    </p>
                  </div>
                  <div>
                    <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                      {summary.totalTransactions}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-span-1 flex flex-col text-center bg-white divide-y divide-gray-200">
                <div>
                  <Link to={"/transfers?tranfertype=intra"}>
                    <div className="relative flex bg-blue-100 pt-5 px-4 pb-5 justify-between sm:pt-6 sm:px-6 mb-6 shadow rounded-lg overflow-hidden">
                      <div className="absolute bg-slate-900 rounded-md p-2">
                        <img
                          src={TotalTransfer}
                          alt="transfers"
                          className="h-6 w-6 text-gray-900"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="text-left mt-12">
                        <p className="text-sm font-medium text-gray-500 truncate">
                          Intra-Bank Transfers
                        </p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {FormatMoney(summary.totalIntraBankTransferAmount)}
                        </p>
                      </div>
                      <div>
                        <p className="flex items-baseline text-sm font-semibold block text-green-500 mt-3 contents">
                          {summary.totalIntraBankTransfer}
                        </p>
                      </div>
                    </div>
                  </Link>
                  <Link to={"/investments"}>
                    <div className="relative flex  justify-between bg-blue-100 pt-5 px-4 pb-6 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                      <div className="absolute bg-slate-900 rounded-md p-2">
                        <img
                          src={Investment}
                          alt="investment"
                          className="h-6 w-6 text-gray-900"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="text-left mt-12">
                        <p className="text-sm font-medium text-gray-500 truncate">
                          Investments
                        </p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {FormatMoney(summary.totalInvestmentAmount)}
                        </p>
                      </div>
                      <div>
                        <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                          {summary.totalInvestment}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-span-1 flex flex-col text-center bg-white  divide-y divide-gray-200">
                <div>
                  <Link to={"/transfers?transfertype=inter"}>
                    <div className="mb-6 relative flex justify-between bg-blue-100 pt-5 px-4 pb-6 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                      <div className="absolute bg-slate-900 rounded-md p-2">
                        <img
                          src={TotalWithdrawals}
                          alt="withdrawals"
                          className="h-6 w-6 text-gray-900"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="text-left mt-12">
                        <p className="text-sm font-medium text-gray-500 truncate">
                          Inter-bank Transfers
                        </p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {FormatMoney(summary.totalInterBankTransferAmount)}
                        </p>
                      </div>
                      <div>
                        <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                          {summary.totalInterBankTransfer}
                        </p>
                      </div>
                    </div>
                  </Link>

                  <div className="pt-12 px-6 pb-6 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden bg-blue-100">
                    <div className="relative flex justify-between bg-blue-100   rounded-lg overflow-hidden">
                      <div className="absolute bg-slate-900 rounded-md p-2">
                        <img
                          src={TotalDeposit}
                          alt="deposits"
                          className="h-6 w-6 text-gray-900"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="text-left mt-12">
                        <p className="text-sm font-medium text-gray-500 truncate">
                          Loans
                        </p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {FormatMoney(summary.totalLoansAmount)}
                        </p>
                      </div>
                      <div>
                        <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                          {summary.totalLoans}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-1 flex flex-col text-center bg-white divide-y divide-gray-200">
                <div>
                  <Link to={"/withdrawal/pickup"}>
                    <div className="relative flex justify-between bg-blue-100 pt-5 px-4 pb-6 sm:pt-6 mb-6  sm:px-6 shadow rounded-lg overflow-hidden">
                      <div className="absolute bg-slate-900 rounded-md p-2">
                        <img
                          src={TotalDeposit}
                          alt="deposits"
                          className="h-6 w-6 text-gray-900"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="text-left mt-12">
                        <p className="text-sm font-medium text-gray-500 truncate">
                          Cash Pickup
                        </p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {FormatMoney(summary.totalCashPickUpAmount)}
                        </p>
                      </div>
                      <div>
                        <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                          {summary.totalCashPickUp}
                        </p>
                      </div>
                    </div>
                  </Link>
                  <div className="relative flex justify-between bg-blue-100 pt-5 px-4 pb-6 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                    <div className="absolute bg-slate-900 rounded-md p-2">
                      <img
                        src={TotalWithdrawals}
                        alt="withdrawals"
                        className="h-6 w-6 text-gray-900"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="text-left mt-12">
                      <p className="text-sm font-medium text-gray-500 truncate">
                        ATM Cardless Withdrawals
                      </p>
                      <p className="text-2xl font-semibold text-gray-900">
                        {FormatMoney(summary.totalWithdrawalAmount)}
                      </p>
                    </div>
                    <div>
                      <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                        {summary.totalWithdrawal}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="max-w-7xl mx-auto ">
              <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                <Link to={"/payment/bill"}>
                  <div className="pt-12 px-6 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden bg-blue-100">
                    <div className="relative flex justify-between bg-blue-100   rounded-lg overflow-hidden">
                      <div className="absolute bg-slate-900 rounded-md p-2">
                        <img
                          src={TotalPayments}
                          alt="payment"
                          className="h-6 w-6 text-gray-900"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="text-left mt-12">
                        <p className="text-sm font-medium text-gray-500 truncate">
                          Bill Payments
                        </p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {FormatMoney(summary.totalPaymentAmount)}
                        </p>
                      </div>
                      <div>
                        <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                          {summary.totalPayment}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
                <Link to={"/payment/recharge"}>
                  <div className="pt-12 px-6 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden bg-blue-100">
                    <div className="relative flex justify-between bg-blue-100   rounded-lg overflow-hidden">
                      <div className="absolute bg-slate-900 rounded-md p-2">
                        <img
                          src={TotalDeposit}
                          alt="deposits"
                          className="h-6 w-6 text-gray-900"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="text-left mt-12">
                        <p className="text-sm font-medium text-gray-500 truncate">
                          Airtime Purchases
                        </p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {FormatMoney(summary.totalAirtimePaymentAmount)}
                        </p>
                      </div>
                      <div>
                        <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                          {summary.totalAirtimePayment}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>

                <Link to={"/payment/recharge"}>
                  <div className="pt-12 px-6 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden bg-blue-100">
                    <div className="relative flex justify-between bg-blue-100   rounded-lg overflow-hidden">
                      <div className="absolute bg-slate-900 rounded-md p-2">
                        <img
                          src={TotalDeposit}
                          alt="deposits"
                          className="h-6 w-6 text-gray-900"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="text-left mt-12">
                        <p className="text-sm font-medium text-gray-500 truncate">
                          Data Purchases
                        </p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {FormatMoney(summary.totalDataPaymentAmount)}
                        </p>
                      </div>
                      <div>
                        <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                          {summary.totalDataPayment}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>

                <Link to={"/transfers"}>
                  <div className="pt-12 px-6 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden bg-blue-100">
                    <div className="relative flex justify-between bg-blue-100   rounded-lg overflow-hidden">
                      <div className="absolute bg-slate-900 rounded-md p-2">
                        <img
                          src={TotalDeposit}
                          alt="deposits"
                          className="h-6 w-6 text-gray-900"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="text-left mt-12">
                        <p className="text-sm font-medium text-gray-500 truncate">
                          Payroll
                        </p>
                        <p className="text-2xl font-semibold text-gray-900">
                          {FormatMoney(summary.totalPayrollAmount)}
                        </p>
                      </div>
                      <div>
                        <p className="flex items-baseline text-sm font-semibold block text-green-500 contents">
                          {summary.totalPayroll}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              </dl>
            </div>
            <div className="max-w-7xl mx-auto ">
              <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                <Link to={"/customers"}>
                  <div className="pt-12 px-6 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden bg-green-50">
                    <div className="grid grid-cols-2">
                      <div>
                        <span>
                          <CursorClickIcon
                            className="h-6 w-6 text-gray-900"
                            aria-hidden="true"
                          />
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="mt-5 text-sm font-medium text-gray-500 truncate">
                        Total Customers Onboarded
                      </p>
                      <p className="text-2xl font-semibold text-gray-900">
                        {summary.totalSignedUpCustomer}
                      </p>
                    </div>
                  </div>
                </Link>
                <Link to={"/accounts"}>
                  <div className="pt-12 px-6 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden bg-green-50">
                    <div className="grid grid-cols-2">
                      <div>
                        <span>
                          <MailOpenIcon
                            className="h-6 w-6 text-gray-900"
                            aria-hidden="true"
                          />
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="mt-5 text-sm font-medium text-gray-500 truncate">
                        Total Account Opened
                      </p>
                      <p className="text-2xl font-semibold text-gray-900">
                        {summary.totalAccountOpened}
                      </p>
                    </div>
                  </div>
                </Link>
                <Link to={"/request/card"}>
                  <div className="pt-12 px-6 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden bg-green-50">
                    <div className="grid grid-cols-2">
                      <div>
                        <span>
                          <UsersIcon
                            className="h-6 w-6 text-gray-900"
                            aria-hidden="true"
                          />
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="mt-5 text-sm font-medium text-gray-500 truncate">
                        Total Card Requests
                      </p>
                      <p className="text-2xl font-semibold text-gray-900">
                        {summary.totalCardRequest}
                      </p>
                    </div>
                  </div>
                </Link>
                <Link to={"/pos"}>
                  <div className="pt-12 px-6 pb-12 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden bg-green-50">
                    <div className="grid grid-cols-2">
                      <div>
                        <span>
                          <CursorClickIcon
                            className="h-6 w-6 text-gray-900"
                            aria-hidden="true"
                          />
                        </span>
                      </div>
                    </div>
                    <div>
                      <p className="mt-5 text-sm font-medium text-gray-500 truncate">
                        Total POS Request
                      </p>
                      <p className="text-2xl font-semibold text-gray-900">
                        {summary.totalPosRequest}
                      </p>
                    </div>
                  </div>
                </Link>
              </dl>
            </div>
          </div>
          <TransferGraph />
          <div className="my-5">
            <BillGraph />
          </div>
        </div>
      </Layout>
    </>
  );
}
